module.exports = __webpack_public_path__ + "media/images/flags/sz-fbb16508f3767203f5f14319774d3f61.svg";